module.exports = __webpack_public_path__ + "static/media/5-lions.bbfcd242.gif";